import { TermlyPolicyEmbed } from '../../pages/TermlyPolicyEmbed';
import type { ReactElement } from 'react';

export const createPolicyPage =
  (dataId: string): (() => ReactElement) =>
  () => <TermlyPolicyEmbed dataId={dataId} />;
